import React, { Component } from 'react';
import { connect } from 'react-redux'
import { default as BlottingPaper } from 'components/blottingPaper/Results';
import SceneData from 'data/scene.json';

import './Results.scss';

import { withTranslation } from 'react-i18next'

import {
  saveResultFeedback
} from '../../../../actions';

class Results extends Component {
    constructor(props) {
        super(props);

        this.state = {
          results: [],
          feedback: ''
        }
    }

    buildComponent = (data) => {

      const components = data.components.map((component, index) => (
        <BlottingPaper key={index} id={component.props.id} />
      ));
      return (components)
    }

    componentDidMount(){
      this.setState({
          results: this.buildComponent(SceneData["Blotting Paper"])
      })
    }

    // handleFormSubmit = (e) => {
    //   e.preventDefault();
    //   // this.setState({
    //   //   feedback: ''
    //   // });
    //
    //   this.props.saveResultFeedback(this.state.feedback);
    // }


    handleFormChange = (e) => {
      this.setState({
          feedback: e.target.value
      }, function(){
        this.props.saveResultFeedback({resultFeedback: this.state.feedback});
      })
    }

    render() {
        return (
          <div className="Results">
              <div>
                  <p 
                    className="description" 
                    tabIndex={0}>
                      {this.props.t("Look at the relative size difference between your micropipetted circles. You should be able to see that accuracy of the liquid transferred is very important and will impact the success of your experiments. Compare your results with the ideal results. If the size of your circles matches the circles in the ideal results, you have pipetted the correct volumes. If they do not match, you have pipetted either too much or too little liquid.")}
                  </p>
              </div>
              <div>
                {this.state.results}
              </div>
              <div>
                <h5 tabIndex={0}>{this.props.t("Results Feedback")}</h5>
                <p className="description" tabIndex={0}>{this.props.t("What part of the procedure do you think had the greatest impact on the results you obtained?")}</p>
                {
                  (
                    <form class="result-feedback" onSubmit={(e) => { e.preventDefault() }}>
                      <textarea placeholder={this.props.t("Type your answer here.")} aria-label={this.props.t("Text-entry field. Input text to answer the question.")} onChange={this.handleFormChange}>{((this.props.resultFeedback !== '')?this.props.t(this.props.resultFeedback):"")}</textarea>
                      {/* <div class="btns">
                        <button disabled={(this.props.resultFeedback == this.state.feedback)} aria-label="Save note button. Select to save changes you’ve made to your notes." type="submit" onClick={this.handleFormSubmit}>Save response</button>
                      </div> */}
                    </form>
                  )
                }
              </div>
          </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        resultFeedback: state.scene.resultFeedback,
    }
}

export default connect(mapStateToProps, {
    saveResultFeedback,
})(withTranslation()(Results));
